<button mat-raised-button [disabled]="isDownloading || !href" (click)="onDownloadFile()">
    @if(isDownloading){<mat-spinner diameter="15"></mat-spinner>}@else{<mat-icon>download</mat-icon>} {{ fileName }} (Download)
</button>
